module.exports = "/packs/images/sprites/circular~95d2d400e1375da19e709a3441628411.svg";